import { z } from 'zod';

import { paramKindFor } from './Shelves.vocabulary';

/**
 * One schema drives the resolver **and** the request shape, and the TS type is
 * derived from it rather than hand-written in parallel.
 *
 * The parameter rule is the one branch worth stating: three of the configured
 * sources resolve against something and the rest resolve on their own, so the
 * same field is required on one source and forbidden on another. Both
 * directions are checked, because a parameter left behind after the operator
 * switched the source is the shape the server refuses with
 * `CONTENT_SHELF_SOURCE_PARAMETER_INVALID` — catching it here turns a round
 * trip into a field error.
 *
 * The messages are **codes**, not sentences: the copy file owns the Arabic, and
 * a schema that carried it would be a second copy source.
 */
export const shelfFormSchema = z
  .object({
    title: z.string().trim().min(1, 'title.required'),
    source: z.string().min(1),
    paramValues: z.array(z.string()),
  })
  .superRefine((values, context) => {
    const kind = paramKindFor(values.source);

    if (kind && values.paramValues.length === 0) {
      context.addIssue({ code: z.ZodIssueCode.custom, path: ['paramValues'], message: 'param.required' });
    }

    if (!kind && values.paramValues.length > 0) {
      context.addIssue({ code: z.ZodIssueCode.custom, path: ['paramValues'], message: 'param.forbidden' });
    }
  });

export type ShelfFormValues = z.infer<typeof shelfFormSchema>;
